import axiosInstance from "./axiosInstance";

export const createProduction = async ({ product_id, qty }) => {
  const res = await axiosInstance.post("/pos/production", { product_id, qty });
  return res.data;
};

export const fetchProductions = async ({
  page = 1,
  limit = 10,
  search = "",
  startDate = "",
  endDate = "",
  view = "detailed",
  branchId = "",
} = {}) => {
  const res = await axiosInstance.get("/pos/production", {
    params: { page, limit, search, startDate, endDate, view, branch_id: branchId || undefined },
  });
  return res.data;
};
